<template>
  <div class="content-container">
    <a-form-model class="search-form" layout="inline" :model="searchForm">
      <a-form-model-item
        class="search-work-style"
        :label="$t('form.common.field.workName.label2')"
      >
        <a-input
          v-model="searchForm.keywords"
          :placeholder="
            $t(
              this.userInfo.type === 1
                ? 'form.common.field.workName.adminHolder'
                : 'form.common.field.workName.agentHolder'
            )
          "
          style="width: 200px"
          @keyup.enter="search"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" style="margin-left: 15px" @click="search">{{
          $t(`actionTitles.search`)
        }}</a-button>
        <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
          $t(`actionTitles.clear`)
        }}</a-button>
      </a-form-model-item>
    </a-form-model>
    <div class="table-wrapper">
      <a-row type="flex" justify="space-between" style="marginbottom: 10px">
        <!-- <a-button type="primary" icon="download">{{$t(`message.offlineDownload`)}}</a-button> -->
      </a-row>
      <clear-selected
        alert-type="error"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />
      <a-table
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :data-source="tableData"
        :loading="loading"
        rowKey="id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <a-table-column
          key="name"
          :title="$t('table.common.thead.name')"
          data-index="name"
        >
          <template slot-scope="text, record">
            <a-row type="flex" align="middle">
              <img
                :src="record.thumb_path"
                alt
                style="width: 40px; margin-right: 10px; cursor: pointer"
                @click="toTour(record)"
              />
              <div>
                <span @click="toTour(record)" class="toFolder">{{
                  record.name
                }}</span>
                <br />
                <span>{{ record.regoin_name }}</span>
              </div>
            </a-row>
          </template>
        </a-table-column>
        <a-table-column
          key="user_name"
          :title="$t('table.work.thead.userName')"
          data-index="user_name"
        >
          <template slot-scope="text, record">
            <div>
              <span>{{ record.user_name }}</span>
              <br />
              <span>{{ record.user_phone }}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column
          key="dealer_name"
          :title="$t('table.common.thead.dealer')"
          data-index="dealer_name"
          v-if="userInfo.type != 3 && userInfo.store_id == ''"
        >
          <template slot-scope="text, record">
            <div>
              <span>{{ record.dealer_name }}</span>
              <br />
              <span>{{ record.dealer_phone }}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column
          key="user_store_id"
          title="加盟店"
          data-index="user_store_id"
          v-if="userInfo.store_id != ''"
        >
          <template slot-scope="text, record">
            <div>{{text}}</div>
          </template>
        </a-table-column>
        <a-table-column
          key="customer_name"
          :title="$t('table.work.thead.customerName')"
          data-index="customer_name"
        >
          <template slot-scope="text, record">
            <div>
              <span>{{ record.customer_name }}</span>
              <br />
              <span>{{ record.customer_phone }}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column
          key="total_browse"
          :title="$t('table.work.thead.readCount')"
          data-index="total_browse"
          :sorter="true"
          align="center"
        >
          <template slot-scope="text, record">{{
            record.total_browse != undefined ? record.total_browse : "-"
          }}</template>
        </a-table-column>
        <a-table-column
          key="is_public"
          :title="$t('table.common.thead.state')"
          data-index="is_public"
          :filters="filters"
          align="center"
          v-if="userInfo.store_id == ''"
        >
          <template slot-scope="text, record">{{
            record.is_public != undefined
              ? $t(`enum.workIsPublic.${record.is_public}`)
              : "-"
          }}</template>
        </a-table-column>
        <a-table-column
          key="thing_no"
          title="物件編號"
          data-index="thing_no"
          align="center"
          v-if="userInfo.store_id != ''"
        >
          <template slot-scope="text, record">
            <div @click="clickThingNo(record)">{{text == '' ? '點擊新增' : text}}</div>
          </template>
        </a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.updateTime')"
          :sorter="true"
          data-index="create_time"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.create_time ? record.create_time : "-" }}</span>
          </template>
        </a-table-column>
        <a-table-column
          v-if="userInfo.type === 1"
          key="recommend"
          :title="$t('table.common.thead.recommend')"
          :sorter="true"
          data-index="recommend"
          align="center"
        >
          <template slot-scope="text, record">
            <div v-if="record.dir_id != undefined">
              <a-icon
                v-if="record.recommend == 0"
                @click="recommend(record)"
                style="color: red"
                type="close"
              />
              <a-icon
                v-else
                style="color: green"
                @click="recommend(record)"
                type="check"
              />
            </div>
            <div v-else>-</div>
          </template>
        </a-table-column>

        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span v-if="record.dir_id != undefined">
              <a @click="share(record)">{{ $t("actionTitles.share") }}</a>
              <a-divider type="vertical" />

              <span v-if="userInfo.type == 1 || userInfo.type == 3">
                <a @click="onClickEdit(record)" v-if="record.type==1">{{
                  $t("actionTitles.edit")
                }}</a>
                <a-divider type="vertical" v-if="record.type==1"/>
                <a @click="talk(record.id)">{{ $t("actionTitles.talk") }}</a>
                <a-divider type="vertical" />
                <!-- 刪除確認框-->
                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="handleDelete(record.id, 'pano')"
                >
                  <template slot="title">{{
                    $t("message.softDeleteHint")
                  }}</template>
                  <a style="color: red">{{ $t("actionTitles.delete") }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
              </span>
              <a @click="offLineDownload(record)" v-if="record.type==1 && userInfo.store_id == ''">{{
                $t("actionTitles.offlineDownload")
              }}</a>
              <a-divider type="vertical" v-if="record.type==1 && userInfo.store_id == ''"/>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      v-model="shareVisible"
      :title="$t('actionTitles.share')"
      :width="800"
      :destroyOnClose="true"
      @ok="() => (this.shareVisible = false)"
    >
      <share :work-id="shareWorkId" :share-type="shareType"></share>
    </a-modal>

    <a-modal
      v-model="talkVisible"
      :title="$t('actionTitles.talk')"
      :width="850"
      :destroyOnClose="true"
      :footer="null"
      @ok="() => (this.talkVisible = false)"
    >
      <a-table
        :data-source="talkData.data"
        :loading="talkLoading"
        :pagination="talkPagination"
        rowKey="id"
        @change="handleTalkTableChange"
      >
        <a-table-column
          key="nickname"
          :title="$t('table.common.thead.reviewer')"
          data-index="nickname"
          align="center"
        >
          <template slot-scope="text, record">
            <div class="talk-reviewer">
              <img
                :src="
                  record.head_img
                    ? record.head_img
                    : '/ssr/static/images/default_avatar.jpg'
                "
                alt=""
                style="width: 40px; margin-right: 10px"
              />
              <a style="color: #000" :title="record.nickname">{{
                record.nickname.length > 4
                  ? record.nickname.slice(0, 4) + "..."
                  : record.nickname
              }}</a>
            </div>
          </template>
        </a-table-column>

        <a-table-column
          key="content"
          :title="$t('table.common.thead.content')"
          data-index="content"
          align="center"
          width="50%"
        ></a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.createTime')"
          data-index="create_time"
          align="center"
        ></a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => deleteTalk(record.id)"
              >
                <a href="javascript:;" style="color: red">
                  {{ $t(`actionTitles.delete`) }}
                </a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <!--    物件編號-->
    <a-modal
      v-model="thingNoVisible"
      title="物件編號"
      :destroyOnClose="true"
      @ok="() => (this.shareVisible = false)"
    >
      <div style="display: flex;justify-content: space-between">
        <a-input v-model="selectThingData.thing_no" placeholder="請輸入物件編號" style="width: 75%"></a-input>
        <a-button type="primary" @click="clickBindThingNo">綁定</a-button>
        <!--        <a-button type="danger" v-else>取消綁定</a-button>-->
      </div>
    </a-modal>
  </div>
</template>

<style scoped>
.toFolder:hover {
  cursor: pointer;
  color: #1890ff;
}
.release .ant-row-flex-middle {
  margin-top: 20px;
}
.release img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  float: left;
}
.release .workName {
  float: left;
}
.release .ant-progress-outer {
  width: 80%;
}
.release .progress {
  font-size: 12px;
  text-align: center;
}
.talk-reviewer {
  display: flex;
  align-items: center;
}
</style>
<script>
import { mapState } from "vuex";
import ClearSelected from "../../components/ClearSelected";
import {
  queryAll,
  recommend,
  softDelete,
  queryTalk,
  delTalk,
} from "@/api/work";
import Share from "@/components/Share";
import { download } from "@/utils/offlineDownload";
import {bindThingNo,checkThingNoBind} from "@/api/ting"

export default {
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      searchForm: {
        uid: "",
        keywords: "",
        is_public: [],
        order: [],
      },
      pageResult: {},
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      selectedKeys: [],
      tableData: [],
      filters: [
        {
          text: `${this.$t("enum.workIsPublic[1]")}`,
          value: "1",
        },
        {
          text: `${this.$t("enum.workIsPublic[0]")}`,
          value: "0",
        },
      ],
      shareVisible: false,
      shareWorkId: 0,
      shareThumbPath: "",
      talkVisible: false, //說一說
      talkData: [],
      shareType: "tour",
      talkLoading: false,
      queryTalkParams: {
        wid: "",
        current_page: 1,
        per_page: 10,
      },
      talkPagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      selectThingData:{
        work_id:0,
        thing_no:'',
        store_id:'',
        store_type:'',
        vr_url:'',
      },
      thingNoVisible:false,
    };
  },
  components: { ClearSelected, Share },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    let uid = this.$route.query.uid;
    if (uid) {
      this.searchForm.uid = uid;
    }
    this.loadData();
  },
  methods: {
    recommend(record) {
      let userType = this.$store.getters.userInfo.type;
      if (userType == 1) {
        let workInfo = { id: record.id };
        workInfo.recommend = record.recommend == 1 ? 0 : 1;
        recommend(workInfo).then((res) => {
          this.loadData();
        });
      }
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleTableChange(pagination, filters, sorter) {
      console.log("11");
      this.pagination = pagination;
      if (Object.keys(filters).length > 0) {
        this.searchForm.is_public = filters.is_public;
      }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
        console.log(this.searchForm.order);
      }
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };

      queryAll(this.searchParam)
        .then((ret) => {
          this.loading = false;
          this.pageResult = ret.data;
          // this.tableData = ret.data.records;
          this.pagination.total = ret.data.total;
          this.selectedRowKeys = [];
          this.selectedRows = [];
          this.tableData = this.pageResult.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.searchForm = {
        uid: "",
        keywords: "",
        is_public: [],
        order: [],
      };
      this.pagination.current = 1;
      this.loadData();
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },
    share(item) {
      this.shareType = item.type==2 ? "live" : "tour";
      this.shareWorkId = item.uuid;
      this.shareThumbPath = item.thumb_path;
      this.shareVisible = true;
    },
    toTour(item) {
      const { href } = this.$router.resolve({
        path: (item.type==2 ? "/live/" : "/tour/") + `${item.uuid}`,
      });
      window.open(href, "_blank");
    },
    offLineDownload(itemObj) {
      download(itemObj);
    },
    onClickEdit(record) {
      if (this.userInfo.type == 3) {
        this.$router.push({
          path: "/edit",
          query: { id: record.id, employeeId: this.searchForm.uid },
        });
      } else {
        this.$router.push({ path: "/edit", query: { id: record.id } });
      }
    },
    handleDelete(id, type) {
      let deletelist = [{ id: id, type: type }];
      softDelete(deletelist).then((res) => {
        this.$message.success(this.$t("message.deleteSuccess"));
        this.loadData();
      });
    },
    //說一說
    onClickTalk() {
      this.talkLoading = true;
      let queryTalkParams = {
        ...this.queryTalkParams,
        ...{
          current_page: this.talkPagination.current,
          per_page: this.talkPagination.pageSize,
        },
      };
      queryTalk(queryTalkParams)
        .then((res) => {
          if (res.code === 1 && res.data.data.length) {
            console.log("說一說=", res);
            this.talkLoading = false;
            this.talkData = res.data;
            this.talkPagination.total = res.data.total;
            this.talkVisible = true;
          } else {
            this.talkLoading = false;
            this.talkPagination.total = res.data.total;
            this.talkVisible = true;
            this.talkData = [];
          }
        })
        .catch((err) => {
          this.talkLoading = false;
          console.log("queryTalk err=", err);
        });
    },
    deleteTalk(Tid) {
      delTalk({ id: Tid })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.talkPagination.current = 1;
              this.onClickTalk();
            });
          }
        })
        .catch((err) => {
          console.log("delTalk err =", err);
        });
    },
    handleTalkTableChange(pagination, filters, sorter) {
      this.talkPagination = pagination;
      // if (Object.keys(sorter).length > 0) {
      //   let field = sorter.field;
      //   let orderStr = sorter.order == "ascend" ? "asc" : "desc";
      //   let order = {};
      //   order[field] = orderStr;
      //   this.queryTalkParams.order = order;
      // }
      this.onClickTalk();
    },
    talk(wid) {
      this.queryTalkParams.wid = wid;
      this.talkPagination.current = 1;
      this.onClickTalk();
    },
    clickThingNo(record){
      this.selectThingData.work_id = record.id;
      this.selectThingData.thing_no = record.thing_no;
      this.selectThingData.store_id = this.userInfo.store_id;
      this.selectThingData.store_type = this.userInfo.store_type;
      this.selectThingData.vr_url = "https://www.qwhouse720.com/tour/"+record.uuid;
      this.thingNoVisible = true;
      console.log("this.selectThingData===>",this.selectThingData);
      console.log(record)
    },
    clickBindThingNo(){
      console.log("觸發clickBindThingNo")
      let that = this;
      checkThingNoBind(this.selectThingData).then(res=>{
        if (res.data.isBind == 1){
          this.$confirm({
            title: '確認綁定？',
            content: '繼續此操作將清除原有綁定，是否繼續？',
            okText: '確認',
            cancelText: '取消',
            onOk(){
              bindThingNo(that.selectThingData).then(res=>{
                that.$message.success(that.$t("message.saveSuccess"));
                that.thingNoVisible = false;
                that.loadData();
              })
            }
          });
        }else{
          bindThingNo(that.selectThingData).then(res=>{
            that.$message.success(that.$t("message.saveSuccess"));
            that.thingNoVisible = false;
            that.loadData();
          })
        }
        console.log(res)
      })
    }
  },
};
</script>

<style lang="less" scoped>
</style>
